$(function() {
    var url = '/pages/agreement'; // 利用規約のURL
    var message = '<a href="' + url + '" target="_blank" class="agreement-url_string">利用規約</a>に同意し注文します'; // 表示するメッセージ
    var agreementArea = '<div class="cart__agree-checkbox"><input type="checkbox" id="check">' + '<label for="check">' + message + '</label></div>'; //利用規約エリア要素
　　　 const checkoutButton = $('.card__section .cart-recap__checkout'); // 購入画面へボタン

    // 購入画面へボタン要素の前に、利用規約エリア要素を配置
    checkoutButton.before(agreementArea);

    // 「ご購入手続きへ」ボタンの初期状態をdisabledに設定
    checkoutButton.prop('disabled', true);

    $('#check').change(function() {
        if ($(this).is(':checked')) {
            checkoutButton.prop('disabled', false);
        } else {
            checkoutButton.prop('disabled', true);
        }
    });
});